import { calculateWeeklyPayrollTotals } from '../../utils/helpers/TotalHoursFormat';
import { payrollValidationTypes } from '../types/payrollValidationTypes';

const initialState = {
  dateStart: '',
  dateEnd: '',
  resultBar: null,
  requestDay: [],
  payrollWeekValidation: [],
  payrollResultWeekValidation: [],
  absentValidation: [],
  changeValueAbsent: [],
  backupPayrollWeekValidation: []
};

export const payrollValidationReducer = (state = initialState, action) => {
  switch (action.type) {
    case payrollValidationTypes.ADD_PAYROLL_VALIDATION: {
      const { employees, date1, date2 } = action.payload;
      const calculatedPayroll = calculateWeeklyPayrollTotals(employees, date1);
      return {
        ...state,
        dateStart: date1,
        dateEnd: date2,
        payrollWeekValidation: calculatedPayroll,
        backupPayrollWeekValidation: JSON.parse(JSON.stringify(calculatedPayroll))
      };
    }
    case payrollValidationTypes.ADD_PAYROLL_ABSENT_VALIDATION: {
      const newAbsent = action.payload?.map((payroll) => {
        for (const [key, value] of Object.entries(payroll)) {
          if (key !== null) {
            if (value) {
              if (value.totalRegHour === 0 && value.totalOtHour === 0) {
                return payroll;
              }
            }
          }
        }
        return payroll;
      });
      return {
        ...state,
        absentValidation: newAbsent
      };
    }

    case payrollValidationTypes.CHANGE_VALUES_PAYROLL: {
      const { id, day, key, payrollId } = action.payload;
      let { changeValueAbsent } = state;
      let exist = false;
      if (changeValueAbsent?.length > 0) {
        exist = changeValueAbsent.find(
          (item) => item.id === id && item[day]?.payrollId === payrollId && item.day === day && item.key === key
        );
        if (!exist) changeValueAbsent = [...changeValueAbsent, action.payload];
      } else {
        changeValueAbsent = [action.payload];
      }
      if (exist && changeValueAbsent.length > 0) {
        const newValuesChanges = changeValueAbsent.map((data) => {
          if (data.id === id && data.day === day && data[day].payrollId === payrollId && data.key === key) {
            data = action.payload;
            return data;
          }
          return action.payload;
        });
        changeValueAbsent = newValuesChanges;
      }
      return {
        ...state,
        changeValueAbsent
      };
    }

    /* reducer change payrate */
    case payrollValidationTypes.CHANGE_PAYRATE_VALIDATION: {
      const { id, employeeCancel } = action.payload;
      let { payrollWeekValidation, dateStart } = state;
      if (payrollWeekValidation) {
        payrollWeekValidation = payrollWeekValidation.map((employee) => {
          if (employee?.id === id) {
            const employeeCopy = { ...employeeCancel };
            return employeeCopy;
          }
          return employee;
        });
      }
      return {
        ...state,
        payrollWeekValidation: calculateWeeklyPayrollTotals(payrollWeekValidation, dateStart)
      };
    }

    case payrollValidationTypes.CHANGE_WEEK_ATTENDANCE_VALUE: {
      const { id, day, key, value, payrollId } = action.payload;
      let { payrollWeekValidation, dateStart } = state;
      if (payrollWeekValidation) {
        payrollWeekValidation = payrollWeekValidation.map((employee) => {
          if (employee?.id === id && employee[day]?.payrollId === payrollId && employee[day]) {
            return {
              ...employee,
              [day]: {
                ...employee[day],
                [key]: parseFloat(value),
                ...(key === 'attendance' && { attendance: value })
              }
            };
          }
          return employee;
        });
        payrollWeekValidation = calculateWeeklyPayrollTotals(payrollWeekValidation, dateStart);
      }
      return {
        ...state,
        payrollWeekValidation
      };
    }

    case payrollValidationTypes.CHANGE_WEEK_PAYRATE_VALUE: {
      const { id, day, key, value, payrollId } = action.payload;
      let { payrollWeekValidation, dateStart } = state;
      if (payrollWeekValidation) {
        payrollWeekValidation = payrollWeekValidation.map((employee) => {
          if (employee?.id === id && employee[day]?.payrollId === payrollId && employee[day]) {
            return {
              ...employee,
              [day]: {
                ...employee[day],
                [key]: parseFloat(value)
              }
            };
          }
          return employee;
        });
        payrollWeekValidation = calculateWeeklyPayrollTotals(payrollWeekValidation, dateStart);
      }
      return {
        ...state,
        payrollWeekValidation
      };
    }

    // Add hours to employee that had no hours
    case payrollValidationTypes.ADD_HOURS_PAYROLL_VALIDATION: {
      const { id, positionId } = action.payload;
      let { payrollWeekValidation, changeValueAbsent, dateStart } = state;
      const payroll = [];
      if (payrollWeekValidation) {
        changeValueAbsent?.forEach((data) => {
          if (data.id === id) {
            payroll.push(data);
          }
        });

        payrollWeekValidation = payrollWeekValidation.map((employee) => {
          if (employee?.id === id && employee?.position?.positionId === positionId) {
            let updatedEmployee = { ...employee };

            payroll.forEach((payrollData) => {
              if (payrollData.key === 'totalRegHour' && updatedEmployee[payrollData.day]) {
                updatedEmployee = {
                  ...updatedEmployee,
                  [payrollData.day]: {
                    ...updatedEmployee[payrollData.day],
                    totalRegHour: parseFloat(payrollData.value) || 0
                  }
                };
              }
              if (payrollData.key === 'totalOtHour' && updatedEmployee[payrollData.day]) {
                updatedEmployee = {
                  ...updatedEmployee,
                  [payrollData.day]: {
                    ...updatedEmployee[payrollData.day],
                    totalOtHour: parseFloat(payrollData.value) || 0
                  }
                };
              }
            });

            return updatedEmployee;
          }
          return employee;
        });
        payrollWeekValidation = calculateWeeklyPayrollTotals(payrollWeekValidation, dateStart);
      }
      return {
        ...state,
        payrollWeekValidation
      };
    }

    case payrollValidationTypes.CHANGE_HOURS_PAYROLL: {
      const { id, day, key, value, payrollId } = action.payload;
      let { payrollWeekValidation, dateStart } = state;
      if (payrollWeekValidation) {
        payrollWeekValidation = payrollWeekValidation?.map((employee) => {
          if (employee?.id === id && employee[day]?.payrollId === payrollId && employee[day]) {
            return {
              ...employee,
              [day]: {
                ...employee[day],
                [key]: parseFloat(value)
              }
            };
          }
          return employee;
        });
      }
      payrollWeekValidation = calculateWeeklyPayrollTotals(payrollWeekValidation, dateStart);
      return {
        ...state,
        payrollWeekValidation
      };
    }

    case payrollValidationTypes.CANCEL_WEEK_PAYRATE_VALUES: {
      return {
        ...state,
        payrollWeekValidation: action.payload
      };
    }

    case payrollValidationTypes.CHANGE_HOURS_PAYROLL_LOCKED: {
      const { id, day, key, value, payrollId } = action.payload;
      let { payrollWeekValidation, dateStart } = state;
      if (payrollWeekValidation) {
        payrollWeekValidation = payrollWeekValidation?.map((employee) => {
          if (employee?.id === id && employee[day]?.payrollId === payrollId && employee[day]) {
            return {
              ...employee,
              [day]: {
                ...employee[day],
                [key]: parseFloat(value)
              }
            };
          }
          return employee;
        });
      }
      return {
        ...state,
        payrollWeekValidation: calculateWeeklyPayrollTotals(payrollWeekValidation, dateStart)
      };
    }

    case payrollValidationTypes.REQUEST_LIST_SAVING:
      return {
        ...state,
        requestDay: [action.payload]
      };
    case payrollValidationTypes.SAVE_PAYROLL_RESULT_VALIDATION:
      return {
        ...state,
        payrollResultWeekValidation: action.payload
      };

    case payrollValidationTypes.CHANGE_STATE: {
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    }

    case payrollValidationTypes.RESET_ENTIRE_STATE:
      return { initialState };

    case payrollValidationTypes.CLEAR_PROP: {
      return {
        ...state,
        payrollWeekValidation: [],
        absentValidation: [],
        backupPayrollWeekValidation: []
      };
    }

    case payrollValidationTypes.BACKUP_PAYROLL_WEEK_VALIDATION:
      return {
        ...state,
        backupPayrollWeekValidation: JSON.parse(JSON.stringify(state.payrollWeekValidation))
      };

    case payrollValidationTypes.RESTORE_PAYROLL_WEEK_VALIDATION:
      return {
        ...state,
        payrollWeekValidation: state.backupPayrollWeekValidation || state.payrollWeekValidation
      };

    case payrollValidationTypes.CHANGE_WEEK_POSITION_VALIDATION: {
      const { id, currentPositionId, position } = action.payload;
      const { payrollWeekValidation } = state;
      if (payrollWeekValidation) {
        const updatedPayrollWeekValidation = payrollWeekValidation.map((employee) => {
          if (employee?.id === id && employee?.position?.positionId === currentPositionId) {
            const employeeCopy = { ...employee };

            // Update position and department of the main employee
            employeeCopy.position = {
              positionId: position.positionId,
              name: position.name || position.positionName,
              positionName: position.positionName || position.name,
              departmentId: position.departmentId,
              departmentName: position.departmentName
            };

            if (position.departmentId) {
              employeeCopy.department = {
                departmentId: position.departmentId,
                name: position.departmentName || employeeCopy.department?.name
              };
            }

            // Update position and department for each day of the week
            const daysOfWeek = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
            daysOfWeek.forEach((day) => {
              if (employeeCopy[day]) {
                employeeCopy[day] = {
                  ...employeeCopy[day],
                  position: {
                    positionId: position.positionId,
                    name: position.name || position.positionName,
                    positionName: position.positionName || position.name,
                    departmentId: position.departmentId,
                    departmentName: position.departmentName
                  },
                  department: position.departmentId
                    ? {
                        departmentId: position.departmentId,
                        name: position.departmentName || employeeCopy[day]?.department?.name
                      }
                    : employeeCopy[day]?.department
                };
              }
            });

            return employeeCopy;
          }
          return employee;
        });
        return {
          ...state,
          payrollWeekValidation: updatedPayrollWeekValidation
        };
      }
      return state;
    }

    case payrollValidationTypes.CHANGE_DAY_POSITION_VALIDATION: {
      const { id, currentPositionId, position, day, payrollId } = action.payload;
      const { payrollWeekValidation, dateStart } = state;
      if (payrollWeekValidation) {
        const updatedPayrollWeekValidation = payrollWeekValidation.map((employee) => {
          if (employee?.id === id && employee?.position?.positionId === currentPositionId && employee[day]?.payrollId === payrollId) {
            const employeeCopy = { ...employee };

            // Update only the specific day
            if (employeeCopy[day]) {
              const newPayRate = position.pay != null ? parseFloat(position.pay) : employeeCopy[day].payRate || 0;
              const newBillRate = position.bill != null ? parseFloat(position.bill) : employeeCopy[day].billRate || 0;

              employeeCopy[day] = {
                ...employeeCopy[day],
                position: {
                  positionId: position.positionId,
                  name: position.name || position.positionName,
                  positionName: position.positionName || position.name,
                  departmentId: position.departmentId,
                  departmentName: position.departmentName
                },
                department: position.departmentId
                  ? {
                      departmentId: position.departmentId,
                      name: position.departmentName || employeeCopy[day]?.department?.name
                    }
                  : employeeCopy[day]?.department,
                // Update payRate and billRate with the values from the new position
                payRate: newPayRate,
                billRate: newBillRate
              };
            }

            return employeeCopy;
          }
          return employee;
        });
        const calculatedEmployees = calculateWeeklyPayrollTotals(updatedPayrollWeekValidation, dateStart);
        return {
          ...state,
          payrollWeekValidation: calculatedEmployees
        };
      }
      return state;
    }

    default:
      return state;
  }
};
